import { useState } from 'react';
import { Icon } from '../../icon/Icon';

import './styles.scss';

import * as S from './SidebarAccordion.styles';
import { THEME_TYPE } from 'theme';

export interface SidebarAccordionProps {
  readonly label: string;
  readonly testId?: string;
  readonly initialIsOpen?: boolean;
  readonly children?: React.ReactNode | JSX.Element[];
  readonly color: THEME_TYPE['FILTERS_PRIMARY'] | THEME_TYPE['FILTERS_SECONDARY'] | string;
}

export const SidebarAccordion = ({
  testId,
  initialIsOpen = false,
  children,
  label,
  color,
}: SidebarAccordionProps): JSX.Element => {
  const [isOpen, setOpen] = useState(initialIsOpen);

  return (
    <div test-id={testId}>
      <S.Container onClick={(): void => setOpen((p) => !p)} isOpen={isOpen} color={color}>
        <S.Label>{label}</S.Label>
        <S.Arrow isOpen={isOpen}>
          <Icon iconName="Arrow" />
        </S.Arrow>
      </S.Container>
      <S.Content isOpen={isOpen} color={color}>
        {children}
      </S.Content>
    </div>
  );
};
